// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — items.classic.js, новая — items.cp.js
import { isCp } from 'libs/design';
import * as classic from './items.classic';
import * as cp from './items.cp';

export const Items = isCp ? cp.Items : classic.Items;
